import React, { useState, useEffect } from 'react';
/* import { useLanguage } from '../../../../../store/languageContext';
import { LanguageFactory } from '../../../../../factories'; */
import {
  Tabs,
  Card,
  Row,
  Col,
  Button,
  Form,
  Select,
  Modal,
  message,
} from 'antd';
import Input from '../../../../ui/Input';
import TextArea from '../../../../ui/TextArea';
import ActionButtonsBar from '../../../../ui/ActionButtonsBar';
import PageContainer from '../../../../CSIComponents/PageContainer';
import { getOTACodes } from '../../../../../services/common';
import {
  deletePolicyPets,
  updatePolicyPets,
} from './../../../../../services/policy';
import Loading from './../../../../Loading';
import styles from './index.module.css';
import de from 'date-fns/esm/locale/de/index.js';

interface propsTypes {
  petsDetails: any;
  isEditable: void | any;
  cancelEditable: void | any;
  supplier: string;
  propertyId: string;
  changeTab: void | any;
  getPoliciesData: any;
  setPoliciesData: void | any;
  setPetsDetails: void | any;
}

const FormItem = Form.Item;
const Option = Select.Option;
const TabPane = Tabs.TabPane;
const PtesEdit = (props: propsTypes) => {
  /*     const { language, setLanguage } = useLanguage()
    const lang = new LanguageFactory(language) */
  const [typeOptions, setTypeOptions] = useState<any>([]);
  const [currentOptions, setCurrentOptions] = useState<any>([]);
  const [chargeUnitOptions, setChargeUnitOptions] = useState<any>([]);
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [form] = Form.useForm();
  const [disabledStatus, setDisabledStatus] = useState(false);
  const getTypeOptions = async () => {
    const res = await getOTACodes('PET', '');
    if (res.result.success) {
      setTypeOptions(res.otacodes);
    } else {
      setTypeOptions([]);
    }
  };
  const validateFieldsError = (changedValues: any, allValues: any) => {
    form
      .validateFields()
      .then(() => {
        setDisabledStatus(false);
      })
      .catch(() => {
        const detailErrNum = form
          .getFieldsError()
          ?.filter(({ errors }: { errors: any }) => errors.length).length;
        if (detailErrNum === 0) {
          setDisabledStatus(false);
        } else {
          setDisabledStatus(true);
        }
      });
  };
  const getCurrentOptions = async () => {
    const res = await getOTACodes('CUR', '');
    if (res.result.success) {
      setCurrentOptions(res.otacodes);
    } else {
      setCurrentOptions([]);
    }
  };
  const getChargeUnit = async () => {
    const res = await getOTACodes('CHG', 'ChargeUnit');
    if (res.result.success) {
      setChargeUnitOptions(res.otacodes);
    } else {
      setChargeUnitOptions([]);
    }
  };

  useEffect(() => {
    getTypeOptions();
    getCurrentOptions();
    getChargeUnit();
  }, []);

  const ModalHead = () => {
    return (
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          height: '50px',
          lineHeight: '50px',
          textIndent: '10px',
          borderBottom: '1px solid #ccc',
          color: '#fff',
          background: '#06789D',
          fontSize: 18,
          width: '100%',
        }}
      >
        Confirm
      </div>
    );
  };

  const updatePets = () => {
    form
      .validateFields()
      .then((values) => {
        setLoadingFlag(true);
        const requestBody = {
          supplier: props.supplier,
          propertyId: props.propertyId,
          property: {
            policies: {
              petpolicy: [
                {
                  petid: values.petid,
                  petlangid: values.petlangid,
                  name: values.name,
                  type: values.type,
                  size: values.size,
                  uom: values.uom,
                  max: values.max,
                  refundabledeposit: values.refundabledeposit,
                  nonrefundablefee: values.nonrefundablefee,
                  currency: values.currency,
                  chargeunit: values.chargeunit,
                  restrictionsapply: values.restrictionsapply,
                  servicedogsallowed: values.servicedogsallowed,
                  description: values.description,
                },
              ],
            },
          },
        };
        updatePolicyPets(requestBody).then(
          (res) => {
            if (res.result.success) {
              setLoadingFlag(false);
              props.cancelEditable();
              props.setPetsDetails(values);
              // props.setPoliciesData({})
              props.getPoliciesData('PetsDetails');
            } else {
              setLoadingFlag(false);
              message.error({
                content: res?.error[0]?.message || 'operation failed',
              });
            }
          },
          (err) => {
            message.error({
              content: err?.message || err?.error[0]?.message,
            });
            setLoadingFlag(false);
            props.cancelEditable();
            // props.setPoliciesData({})
            // props.getPoliciesData('petsDetails')
          }
        );
      })
      .catch((errorInfo) => {
        // message.error({
        //     content: 'Check all the fields please.',
        // });
      });
  };

  const deleteFees = () => {
    const deleteTitle = 'Ptes Policy 1';
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content: `Are you sure you want to delete ${deleteTitle} ?`,
      cancelText: 'Cancel',
      okText: 'Delete',
      onOk() {
        setLoadingFlag(true);
        const requestBody = {
          supplier: props.supplier,
          propertyId: props.propertyId,
          property: {
            policies: {
              petpolicy: [
                {
                  petid: form.getFieldValue('petid'),
                  petlangid: form.getFieldValue('petlangid'),
                },
              ],
            },
          },
        };
        deletePolicyPets(requestBody).then(
          (res) => {
            setLoadingFlag(false);
            if (res.result.success) {
              props.cancelEditable();
              props.setPoliciesData({});
              props.getPoliciesData('Pets');
            } else {
              message.error({
                content: res?.error[0]?.message || 'operation failed',
              });
            }
          },
          (err) => {
            setLoadingFlag(false);
            props.cancelEditable();
            // props.setPoliciesData({})
            // props.getPoliciesData('Fees')
            message.error({
              content: err?.message || err?.error[0]?.message,
            });
          }
        );
      },
      onCancel() {
        setLoadingFlag(false);
      },
    });
  };

  return (
    <>
      <Tabs defaultActiveKey="detail">
        <TabPane
          tab="Detail"
          key="detail"
        >
          <PageContainer>
            <Card
              style={{ marginTop: -15 }}
              title={props?.petsDetails?.name ? props?.petsDetails?.name : ''}
            >
              <div style={{ padding: '0 16px' }}>
                <Form
                  form={form}
                  layout="vertical"
                  onValuesChange={validateFieldsError}
                  initialValues={{ ...props.petsDetails }}
                >
                  <FormItem
                    name="petid"
                    style={{ display: 'none' }}
                  >
                    <Input />
                  </FormItem>
                  <FormItem
                    name="petlangid"
                    style={{ display: 'none' }}
                  >
                    <Input />
                  </FormItem>
                  <Row gutter={24}>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="name"
                        label="Policy Name"
                        rules={[
                          {
                            max: 128,
                            message:
                              'You have reached the max character length of 128',
                          },
                        ]}
                      >
                        <Input maxLength={128} />
                      </FormItem>
                    </Col>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="type"
                        label="Type"
                        rules={[
                          {
                            required: true,
                            message: 'This field is required',
                          },
                        ]}
                      >
                        <Select allowClear showSearch>
                          {typeOptions.map((item: any) => (
                            <Option
                              value={item.codeName}
                              key={item.codeValue}
                            >
                              {item.codeName}
                            </Option>
                          ))}
                        </Select>
                      </FormItem>
                    </Col>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="size"
                        label="Size"
                        rules={[
                          {
                            pattern: /^\d*(\.\d*)?$/,
                            message: 'This field should be a number',
                          },
                        ]}
                      >
                        <Input />
                      </FormItem>
                    </Col>

                    <Col span={5}></Col>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="uom"
                        label="Unit of Measure"
                      >
                        <Select allowClear showSearch>
                          <Option value="Pound(s)">Pound(s)</Option>
                          <Option value="Kilogram(s)">Kilogram(s)</Option>
                          <Option value="Ounce(s)">Ounce(s)</Option>
                          <Option value="Gram(s)">Gram(s)</Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        extra={<span className="blue-font">Value: 0-99</span>}
                        name="max"
                        label="Maximum Number of Pets"
                        rules={[
                          {
                            pattern: /^(\d|[1-9]\d|99)$/,
                            message: 'This field should be a number',
                          },
                        ]}
                      >
                        <Input />
                      </FormItem>
                    </Col>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="refundabledeposit"
                        label="Refundable Deposlt Amount"
                        rules={[
                          {
                            pattern: /^\d*(\.\d*)?$/,
                            message: 'This field should be a number',
                          },
                        ]}
                      >
                        <Input />
                      </FormItem>
                    </Col>

                    <Col span={5}></Col>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="nonrefundablefee"
                        label="Non-Refundable Fee Amount"
                        rules={[
                          {
                            pattern: /^\d*(\.\d*)?$/,
                            message: 'This field should be a number',
                          },
                        ]}
                      >
                        <Input />
                      </FormItem>
                    </Col>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="currency"
                        label="Currency"
                      >
                        <Select allowClear showSearch>
                          {currentOptions.map((item: any) => (
                            <Option
                              value={item.codeName}
                              key={item.codeValue}
                            >
                              {item.codeName}
                            </Option>
                          ))}
                        </Select>
                      </FormItem>
                    </Col>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="chargeunit"
                        label="Charge Unit"
                      >
                        <Select allowClear showSearch>
                          {chargeUnitOptions.map((item: any) => (
                            <Option
                              value={item.codeName}
                              key={item.codeValue}
                            >
                              {item.codeName}
                            </Option>
                          ))}
                        </Select>
                      </FormItem>
                    </Col>

                    <Col span={5}></Col>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="restrictionsapply"
                        label="Restrictions Apply"
                      >
                        <Select allowClear showSearch>
                          <Option value="true">Yes </Option>
                          <Option value="false">No</Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="servicedogsallowed"
                        label="Service/Guide Dogs Allowed"
                      >
                        <Select allowClear showSearch>
                          <Option value="true">Yes </Option>
                          <Option value="false">No</Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span={12}></Col>
                    <Col
                      span={18}
                      className="col-margin"
                    >
                      <FormItem
                        name="description"
                        label="Description"
                        rules={[
                          {
                            max: 300,
                            message:
                              'You have reached the max character length of 300',
                          },
                        ]}
                      >
                        <TextArea
                          maxLength={300}
                          minRows={3}
                        />
                      </FormItem>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Card>
          </PageContainer>
        </TabPane>
      </Tabs>
      <ActionButtonsBar
        onDelete={deleteFees}
        onCancel={() => {
          props.cancelEditable();
          props.changeTab('PetsDetails');
        }}
        onSave={updatePets}
        disabledSave={disabledStatus}
      />
      {loadingFlag && (
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
          }}
        >
          <Loading type="large" />
        </div>
      )}
    </>
  );
};

export default PtesEdit;
